// Regra de feature flag usada em meta.featureFlag das rotas e nos itens de
// menu. Três formatos:
//   'sla'                      a flag precisa estar ligada;
//   ['reports', 'sla']         todas precisam estar ligadas (decisão 15);
//   { any: ['a', 'b'] }        basta qualquer uma (Captain antigo ou V2).
// Um lugar só decide, para o router, o store e os menus não divergirem.

const isAnyRule = rule =>
  Boolean(rule) && typeof rule === 'object' && !Array.isArray(rule);

const ruleNames = rule => {
  if (Array.isArray(rule)) return rule;
  if (isAnyRule(rule)) return Array.isArray(rule.any) ? rule.any : [];
  return [rule];
};

// A regra pede alguma flag? Lista vazia ou só com valores vazios não pede.
export const hasFeatureFlagRule = rule => ruleNames(rule).some(Boolean);

export const isFeatureFlagRuleEnabled = (rule, features) => {
  const isOn = name => Boolean(name && features?.[name]);
  const names = ruleNames(rule);
  if (isAnyRule(rule)) return names.some(isOn);
  if (Array.isArray(rule)) return names.length > 0 && names.every(isOn);
  return isOn(rule);
};
